import {
  GetWorkAreasDocument,
  UnArchiveWorkAreaDocument,
  UnArchiveWorkAreaMutation,
  UnArchiveWorkAreaMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useUnArchiveWorkArea = () => {
  const [executeMutation] = useMutation(UnArchiveWorkAreaDocument, {
    extractorFn: (data: UnArchiveWorkAreaMutation) =>
      data.locationsMutations.unarchiveLocationsWorkArea,
  })

  const unArchiveWorkArea = async (variables: UnArchiveWorkAreaMutationVariables) => {
    return executeMutation({
      variables,
      refetchQueries: [
        {
          query: GetWorkAreasDocument,
          variables: {
            id: variables.id,
          },
        },
      ],
    })
  }

  return {
    unArchiveWorkArea,
  }
}
